// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.4.0",
    "short": "fcd2b62",
    "branch": "Detached: fcd2b629dd578c47a658dff88a104c3293e6d2e5",
    "date": "2026-8-15"
};
/* eslint:enable */
